import { indicatorsQuery } from './indicatorsQuery';
import { useQueryRefresh, removeConnectionsMemoized } from 'shared/apollo';

export function useIndicatorsQuery() {
  const { data: query, refresh, isLoading } = useQueryRefresh(indicatorsQuery);
  const data = removeConnectionsMemoized(query?.allIndicators)||[];
  return { data, refresh, isLoading };
}